export default __webpack_public_path__ + "static/media/peraonal_bg.25f0229e.png";